<template>
  <!-- 某課程的紀錄清單 -->
  <div class="page rating-record-page" >
    <div class="page-content">
      <template v-if="classImagePath == ''">
        <header
          class="photo-header"
          style="background-image: url(https://image.freepik.com/free-photo/group-diverse-senior-adults-computer-class_53876-30124.jpg);"
        >
        <a class="link back nav-back">
          <i class="material-icons">arrow_back</i>
        </a>
          <template v-if="this.$store.state.backKey===true">
      <f7-navbar :title="courseName" back-link="Back" @click="backIndex()" >
        
          <f7-nav-right >
            <f7-link icon="icon-bars" panel-open="right" ></f7-link>
          </f7-nav-right>
        
      </f7-navbar>
    </template>
    <template v-else>
      <f7-navbar   >
        <div style="width:100%;text-align:center;">
          {{courseName}}
        </div>
      </f7-navbar>
    </template>
        <div class="record-info">
          <h3>{{ courseName }}</h3>
          <p class="sub-content">
            <span>{{ updatedAt.toString().split("T")[0] }} </span>
            <span class="hours">{{ classHours }} hrs</span>
          </p>
        </div>
      </header>
      </template>
      <template v-else>
        <header
          class="photo-header"
          v-bind:style="{'background-image': 'url('+this.$app.cdnUrl +'/' + classImagePath+')'}">
        <a class="link back nav-back">
          <i class="material-icons">arrow_back</i>
        </a>
        <div class="record-info">
          <h3>{{ courseName }}</h3>
          <p class="sub-content">
            <span>{{ updatedAt.toString().split("T")[0] }} </span>
            <span class="hours">{{ classHours }} hrs</span>
          </p>
        </div>
      </header>
      </template>
        
      <!--
      <p class="record-brief">旋轉電機、交流電機、感應機。:STAR:單向感應電動機(蔽極式, 電容式, 分相式)</p> -->
      <template v-if="status==10">
        <div class="rating-wrap">
          <div class="range-slider range-slider-init">
            <input type="range" min="0" max="5" step="0.5" v-model="feedbackScore" />
          </div>
      </div>
      </template>
      <template v-else>
          <div class="rating-wrap">
            <div class="range-slider range-slider-init">
              <input type="range" min="0" max="5" step="0.5" v-model="feedbackScore" disabled/>
            </div>
            <div class="disable-mask"></div>
        </div>
      </template>
      

      <div class="list inline-labels no-hairlines-md">
        <ul>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-input-wrap">
                <textarea row="3" class="resizable filled" v-model="feedbackNote" placeholder="請告訴我們此次上課心得、以及建議"></textarea>
              </div>
            </div>
          </li>
        </ul>
        <template v-if="coachType==20">
          <div class="block">
            <a @click="sendScore()" class="button button-large">送出</a>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Service from "../../../service";
import ScoreSuccess from "./scoreSuccess";
import axios from '../../../js/axiosModule';
import { bus } from '../../../js/bus';

var moment = require('moment');
export default {
  components: {},
  data() {
    return {
      dish: Service.getDish(this.$f7route.params.id),
      tabs: ["申請中", "審核中", "審核通過", "審核不過"],
      isBottom: true,
      loadingFlag:false,
      name:'',
      courseCode:'',
      courseName:'',
      updatedAt:'',
      updatedBy:'',
      studentno:'',
      classHours:'',
      classImagePath:'',
      courseEndAt:'',
      coachType:this.$store.state.coachType,
      id:'',
      applyStatus:'',
      feedbackNote:'',
      feedbackScore:this.$store.state.feedbackScore,
      catchScore:0,
      status:0
    };
  },
  created: function() {
    let self = this;
    bus.$on('rating-bus',function(res){
    //  console.dir(res);
      self.loadingFlag = true;
      self.name = res.chineseName;
      self.courseCode = res.courseCode;
      self.courseName = res.courseName;
      self.updatedAt = res.updatedAt;
      self.updatedBy = res.updatedBy;
      self.studentno = res.studentno;
      self.classImagePath = res.classImagePath;
      self.id = res.id;
      self.classHours= res.classHours;
      self.courseEndAt = res.courseEndAt;
      self.applyStatus = res.applyStatus;
      self.feedbackNote = res.feedbackNote;
   //  self.feedbackScore = res.feedbackScore;
      self.catchScore = res.feedbackScore;
      self.status = res.status;
      self.loadingFlag = false;

    });
  },
  methods: {
    checkHref: function(linkText) {
      this.$f7router.navigate("/" + linkText);
    },
    getNowTime : function() {
      var today = new Date();
      var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      
      var dateTime = moment(date+' '+time,"YYYY-MM-DD HH:mm:ss")._d;  
      return dateTime;
    },
    sendScore: function() {
      let self = this;
      var params = {};
      params.actionFields = "status&feedbackScore&feedbackNote&updateAt&updateBy";
      params.actionValues = {};
      params.actionValues.id = self.id;
      params.actionValues.status = 30;
      params.actionValues.feedbackScore = self.feedbackScore ;
      params.actionValues.feedbackNote = self.feedbackNote;
      params.actionValues.updatedAt = self.getNowTime();
      params.actionValues.updatedBy = self.$store.state.userInfo.studentNo;
      axios.axiosTokenPost(self.$app.axiosUrl+"/api/Coach/UpdateCoachClassRecordByFields",params).then((response)=> {
        if (response.data.status == 200) {
          self.$dialog.modal({
            component: ScoreSuccess,
            title: "",
            //showCloseBtn: this.checked,
            params: { firstInput: "" },

            callback: p => {
              //self.$dialog.alert("已送出", { type: "success", showIcon: false });
             // self.$f7router.navigate("/coin-detail");
           //  console.log("infor");
            }
          });
        }
      }).catch(err=>function() {
        if ( self.$store.state.userInfo === undefined || self.$store.state.userInfo === null ) {
           self.$f7router.navigate("/login");
        } 
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/academic-counseling/counseling/counseling-rating.vue